import React from 'react';

const StatusBadge = ({ status }) => {
  const map = {
    ACTIVE: 'status-active',
    COMPLETED: 'status-completed',
    ON_HOLD: 'status-hold'
  };

  return (
    <span className={`status-badge ${map[status]}`}>
      {status}
    </span>
  );
};

export default StatusBadge;